interface AuthConfig {
    CLIENT_ID: string;
    CLIENT_DOMAIN: string;
    AUDIENCE: string;
    REDIRECT: string;
    SCOPE: string;
}

export const AUTH_CONFIG: AuthConfig = {
    CLIENT_ID: 'K4EU1rb9VdlC2sM79Vxz2DQLkeaVZWe4',
    CLIENT_DOMAIN: 'subsite.auth0.com',
    AUDIENCE: 'https://api.subsite.io/',
    REDIRECT: '/callback',
    SCOPE: 'openid create_token profile email'
};



// WEBPACK FOOTER //
// ./Client/app/shared/auth0-variables.ts